<template>
    <v-btn
      outline
      :small="sidebarStyle === 'portrait' || smallScreen"
      color="primary"
      @click.prevent="resetInteraction()"
      :disabled="interactionMeta.isProcessingData"
      :loading="interactionMeta.isProcessingData">
      Retry
    </v-btn>
</template>

<script>
/* global _ */

// Components:
import EventBus from '@/buses/EventBus';
import PlayerService from '@/services/PlayerService';

// Plugins / Libraries:
import {
  mapGetters,
  mapMutations,
  mapActions,
  mapState
} from 'vuex';


export default {
  name: 'interaction-retake',
  props: {
    interactionId : {
      type: Number,
      required: true,
    },
  },
  computed: {
    ...mapGetters('player', [
      'user',
      'mobile',
      'smallScreen',
      'bulbAttempt',
      'sidebarStyle',
    ]),
    ...mapState('player', [
      'setFirstFocus'
    ]),
    ...mapGetters('interactions', [
      'interactionAttempts'
    ]),
    interaction() {
      return this.$store.getters['interactions/interaction'](this.interactionId) || {};
    },
    interactionAttempt() {
      return this.$store.getters['interactions/interactionAttempt'](this.interactionId) || {};
    },
    interactionMeta() {
      return this.$store.getters['interactions/interactionMeta'](this.interactionId) || {};
    },
  },
  methods: {
    ...mapActions('interactions', [
      'constructInteractionAttempt',
    ]),
    ...mapMutations('interactions', [
      'upsertReplaceInteractionAttempt',
    ]),
    ...mapMutations('player', [
      'setLtiSynced',
      'setSnackbar',
    ]),
    resetInteraction() {
      if (this.user.userType === 'student') {
        this.interactionMeta.isProcessingData = true;
        PlayerService.retryInteraction({
          interactionAttemptId: this.interactionAttempt.id
        }).then(res => {
          this.interactionMeta.isProcessingData = false;
          this.resetInteractionAttempt();
        })
        .catch(err => {
          this.interactionMeta.isProcessingData = false;
          if (err.label === 'read_only_unauthorized') return;
          if (_.has(err, 'response.data.msg')) {
            this.setSnackbar({
  		      	color: 'error',
  		        text: err.response.data.msg,
  		        timeout: 6000,
  		      });
          } else {
            this.setSnackbar({
  		      	color: 'error',
  		        text: `Error when retrying interaction.`,
  		        timeout: 6000,
  		      });
          }
        })
      }
      else {
        this.resetInteractionAttempt();
      }
    },
    resetInteractionAttempt() {
      let interactionAttempt = {
          bulbAttemptId: this.bulbAttempt.id,
          interactionId: this.interaction.id,
          interactionOptionIds: [],
          responseText: [],
          timeElapsed: Date.now(),
        };
        this.upsertReplaceInteractionAttempt(interactionAttempt);
        this.interactionMeta.isInteractionAnswered = false;
        this.interactionMeta.isAnswerCorrect = false;
        this.interactionMeta.isAnswerEmpty = true;
        this.interactionMeta.isExplanationSubmitted = false;
        this.interactionMeta.isRetake = true;
        this.interactionMeta.isRetakeExplanation = false;
        this.$nextTick(() => {
          document.querySelector(`#assist-${this.interaction.id}`).focus();
        });
        this.setLtiSynced(false);
        EventBus.$emit('retakeInteraction', this.interaction.id);
    }
  },
};
</script>
